// extracted by mini-css-extract-plugin
export default {"slide":"g6qt3","pagination":"v1gkV"};